export const APPEND_CONTEXT_TOOL = 'APPEND_CONTEXT_TOOL'
export const REMOVE_CONTEXT_TOOL = 'REMOVE_CONTEXT_TOOL'
